import React from "react";
import Viewer from "react-viewer";

const LightBox = ({ visible, setVisible, photoGallery, activeIndex }) => {
  return (
    <>
      <Viewer
        drag={false}
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        onMaskClick={() => {
          setVisible(false);
        }}
        images={photoGallery}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        downloadable={true}
      />
    </>
  );
};

export default LightBox;
